import { createPromiseAction } from 'redux-saga-promise-actions';
import { createAction } from 'typesafe-actions';
import { TypeLoginPayload, TypeLoginSucceededPayload } from '../types/authAgency';

export const setAgencyTokenPayload = createAction(
  'SET_AGENCY_TOKEN_PAYLOAD',
  (tokenPayload: TypeLoginSucceededPayload) => tokenPayload,
)<TypeLoginSucceededPayload>();

export const loginAgencyRequest = createPromiseAction(
  'LOGIN_AGENCY_REQUEST',
  'LOGIN_AGENCY_REQUEST_SUCCEEDED',
  'LOGIN_AGENCY_REQUEST_FAILURE',
)<TypeLoginPayload, TypeLoginSucceededPayload, undefined>();

export const logoutAgency = createAction('LOGOUT_AGENCY')();
